module.exports = __webpack_public_path__ + "img/alimentacao-color.796e0f58.svg";